import LoaderComponent, { loader } from './loader';
export default LoaderComponent;
export { loader };